import type { IncentivesState } from './types';

const initialState: IncentivesState = {
  eligibilityCheckComplete: false,
  incentiveError: null,
  incentiveSuccess: false,
  incentiveDetails: false,
  incentiveIntroPriceProduct: null,
  incentiveIsLoading: false,
  isEligibilityFailure: false,
  isRedemptionFailure: false,
  promoSource: '',
  giftCardDetails: {},
  giftCardSuccess: false,
};

export default initialState;
